module.exports = __webpack_public_path__ + "img/hound.b7f6690f.jpg";